import {
  FcGeneratorOptions,
  FcGeneratorPositionElementOptions,
  FcPositionProperty,
  FcShape
} from '@dtx-company/flowcode-generator-browser/src'

const tvCodeSizeOptions = {
  outerShapeOutlineSize: 0,
  innerShapeWidth: 45,
  outerShapeWidth: 15,
  insetBorderPadding: 0.11
}

const logoEyesStyle: FcGeneratorPositionElementOptions = {
  ...tvCodeSizeOptions,
  outerShape: FcShape.LOGO,
  innerShape: FcShape.SQUARE,
  text: {
    text: 'FLOWCODE',
    font: 'inter_black',
    fontColor: '#000000',
    fontSize: 12,
    position: { property: FcPositionProperty.DEFAULT, offsetPercentage: 0, extraDegrees: 0 }
  }
}

const otherEyesStyle: FcGeneratorPositionElementOptions = {
  ...tvCodeSizeOptions,
  outerShape: FcShape.SQUARE,
  innerShape: FcShape.SQUARE
}

const tvCodeOptions: FcGeneratorOptions = {
  isTVCode: true,
  containerBackgroundInsetExtend: 4,
  qrdensity: 4,
  containerBorderSize: 7.5,
  containerBorderInsetEyes: 7,
  dataGridPercentageSize: 72,
  radiusMask: 78,
  containerRimPatternSize: 85,
  containerEmptySpaceSize: 6,
  containerText: [
    {
      font: 'inter_medium',
      text: 'PRIVACY.FLOWCODE.COM',
      fontSize: 9,
      position: {
        property: 7,
        offsetPercentage: 3.1,
        extraDegrees: 0
      },
      fontColor: '#000000'
    }
  ]
}

export const TV_CODE_FLOWCODE_OPTIONS: FcGeneratorOptions = {
  ...tvCodeOptions,
  qrrotate: false,
  positionElementTopRight: otherEyesStyle,
  positionElementBottomLeft: logoEyesStyle,
  positionElementTopLeft: otherEyesStyle
}

export const TV_CODE_FLOWCODE_OPTIONS_ROTATED_EYES: FcGeneratorOptions = {
  ...tvCodeOptions,
  qrrotate: true,
  positionElementTopRight: logoEyesStyle,
  positionElementBottomLeft: otherEyesStyle,
  positionElementTopLeft: otherEyesStyle
}

export const getInvertedColorTvCodeProps = (
  isRotated: boolean,
  backgroundColor: string
): FcGeneratorOptions => {
  if (isRotated) {
    return {
      ...TV_CODE_FLOWCODE_OPTIONS_ROTATED_EYES,
      positionElementTopRight: {
        ...logoEyesStyle,
        backgroundColor
      },
      positionElementTopLeft: {
        ...otherEyesStyle,
        backgroundColor
      },
      positionElementBottomLeft: {
        ...otherEyesStyle,
        backgroundColor
      }
    }
  } else {
    return {
      ...TV_CODE_FLOWCODE_OPTIONS,
      positionElementTopRight: {
        ...otherEyesStyle,
        backgroundColor
      },
      positionElementTopLeft: {
        ...otherEyesStyle,
        backgroundColor
      },
      positionElementBottomLeft: {
        ...logoEyesStyle,
        backgroundColor
      }
    }
  }
}

export const getGridModuleSizeForTVCode = (shape?: FcShape | 'heart'): string => {
  switch (shape) {
    case FcShape.SQUARE:
      return '80'
    case FcShape.SHAGGY:
      return '101'
    case 'heart':
    case FcShape.CIRCLE:
      return '95'
    default:
      return '125'
  }
}
